export interface WizardStep {
  key: string;
  label: string;
  type: 'select' | 'text';
  options: string[];
  required: boolean;
  placeholder?: string;
}

export interface RequiredDocument {
  type: string;
  label: string;
  extensions: string[];
  maxMB: number;
}

export interface WizardSchema {
  version: number;
  steps: WizardStep[];
  requiredDocuments: RequiredDocument[];
}

export interface WizardAnswers {
  [key: string]: string;
}

export interface ProjectDraft {
  id: string;
  currentStep: number;
  answers: WizardAnswers;
  wizardState: WizardState;
  documents: ProjectDocument[];
  created_at: string;
  updated_at: string;
}

export interface ProjectDocument {
  id: string;
  type: string;
  document_subtype?: string | null;
  filename: string;
  file_url: string;
  file_size: number;
  mime_type: string;
  uploaded_at: string;
}

export enum WizardState {
  DRAFT = 'DRAFT',
  IN_PROGRESS = 'IN_PROGRESS',
  READY_FOR_DOCS = 'READY_FOR_DOCS',
  READY_FOR_REVIEW = 'READY_FOR_REVIEW',
  SUBMITTED = 'SUBMITTED'
}